import { Card } from "@mui/material";
import { formatNumberForVietnamLocale } from "helper/common-helper";

import classes from "../ReportExtension.module.css";

const ReportExtensionCard = ({ title, value }) => {
  return (
    <Card className={classes.card}>
      <p className={classes.cardTitle}>{title}</p>
      <p className={classes.cardValue}>
        {formatNumberForVietnamLocale(value || 0)}
      </p>
    </Card>
  );
};

export default ReportExtensionCard;
